export function flattenCriteria(criteriaList, parent = null) {
    return criteriaList
        .filter((item) => item.criteria.parent === parent)
        .sort((a, b) => a.weight - b.weight)
        .flatMap((item) => [
            item,
            ...flattenCriteria(criteriaList, item.criteria.id),
        ]);
}
